import { render, staticRenderFns } from "./channel_authorization.vue?vue&type=template&id=57d11c60&scoped=true"
import script from "./channel_authorization.vue?vue&type=script&lang=js"
export * from "./channel_authorization.vue?vue&type=script&lang=js"
import style0 from "./channel_authorization.vue?vue&type=style&index=0&id=57d11c60&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d11c60",
  null
  
)

export default component.exports